import { useEffect, useState } from 'react';
import { authRepository } from '../../../domain/authRepository';

export const useLogin = (isLoginLoading, credentials) => {
    const [loginResult, setLoginResult] = useState();

    useEffect(() => {
        if (isLoginLoading
            && credentials.user
            && credentials.user !== ''
            && credentials.password
            && credentials.password !== ''
        ) {
            authRepository.doLogin(credentials)
            .then((result) => {
                setLoginResult(result)
            })
            .catch((err) => {
                console.error("Failed to do login:", err)
            });
        }
    }, [isLoginLoading, credentials]);

    return loginResult;
}